module.exports = __webpack_public_path__ + "static/media/Google-play.e4548101.svg";